/***********
 * Setup *
 ***********/

// Lodash

window._ = require('lodash');

// Axios

window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

// Vue

import Vue from 'vue';
window.events = new Vue();

// Messaging

window.flash = function (message, type, duration, dismissable = false) {
    if (message.length) {
        window.events.$emit('flash', message, type, duration, dismissable);
    }
};

// Register Vue components

const files = require.context('./', true, /\.vue$/i)
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));

// Initialise Vue app

const app = new Vue({
    el: '#app'
});

// Charts

window.charts = [];

// Echo

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: true
// });

/*******
 * PWA *
 *******/

require('./pwa')
